<template>
  <div class="week-text">
    <h1 class="text-center question-title-v2 mb-4">
      {{ question.question }}
    </h1>
    <div class="text-center">
      <b-form-textarea
        id="textarea"
        v-model="answer"
        class="onboarding-textarea-v2"
        rows="6"
        max-rows="6"
        placeholder="Write something"
      />
      <button
        class="tw-my-5 tw-w-[300px] tw-rounded-lg tw-p-2 tw-uppercase tw-font-bold tw-tracking-[0.15rem] tw-bg-[#a783ff] tw-text-white"
        @click="submitAnswer"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
    },
  },
  data() {
    return {
      answer: '',
    };
  },
  watch: {
    question: {
      handler() {
        this.answer = null;
        if (this.question?.answer) {
          this.answer = this.question.answer;
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.question?.answer) {
      this.answer = this.question.answer;
    }
  },
  methods: {
    submitAnswer() {
      if (this.answer == '' && !this.question?.allowempty) {
        this.$emit('alert', 'The text field cannot be empty');
      } else {
        this.$emit('submitAnswer', this.question.id, this.answer || '');
      }
    },
  },
};
</script>

<style></style>
